import { createSelector } from "reselect";

import getUserAgent from "./getUserAgent";

const getIsMobileSafari = createSelector(
  [getUserAgent],
  (userAgent) => userAgent.isiPad || userAgent.isiPhone || userAgent.isiPod,
);

export default getIsMobileSafari;
